<div class="content">
  <!-- Breadcrumb -->
  <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
    <div class="my-auto mb-2">
      <h2 class="mb-1">
        Running Payroll {{ (runningPayroll$ | async)?.payPeriodStart | date: 'dd MMM' }} to
        {{ (runningPayroll$ | async)?.payPeriodEnd | date: 'dd MMM' }}
      </h2>
      <nav>
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item">
            <a href="#"><i class="ti ti-smart-home"></i></a>
          </li>
          <li class="breadcrumb-item">HRM</li>
          <li class="breadcrumb-item" aria-current="page">
            <a [routerLink]="[eps.hrm.managePayrollPath]">Manage Payroll</a>
          </li>
          <li class="breadcrumb-item active" aria-current="page">Run Payroll</li>
        </ol>
      </nav>
    </div>
    <div class="head-icons ms-2">
      <!--<h2>1/3</h2>-->
    </div>
  </div>
  <!-- /Breadcrumb -->
  <div [ngSwitch]="currentScreenIndex">
    <ng-container *ngSwitchCase="screens[0]">
      <app-earnings (nextScreen)="changeScreen($event)"></app-earnings>
    </ng-container>
    <ng-container *ngSwitchCase="screens[1]">
      <app-review (nextScreen)="changeScreen($event)"></app-review>
    </ng-container>
    <ng-container *ngSwitchCase="screens[2]">
      <app-success></app-success>
    </ng-container>
  </div>
</div>
